module.exports = __webpack_public_path__ + "img/logo.d0c2e1c9.png";